import React from 'react';
import { STATS } from '../utils/heroStats';
import '../styles/statChips.css';
import { useTranslation } from 'react-i18next';
import { tr } from '../../i18n/msg';

/**
 * ⚡ Power + STR / AGI / INT chips. Power = STR + AGI + INT (overall rating) — shown first
 * unless `showPower={false}`. `highlight` = Set of stat keys a mission needs.
 */
export default function StatChips({
  str = 0, agi = 0, int: intel = 0, power, showPower = true, size = 'sm', highlight, className = '',
}) {
  const { t } = useTranslation();
  const values = { str, agi, int: intel };
  const total = power ?? ((Number(str) || 0) + (Number(agi) || 0) + (Number(intel) || 0));
  return (
    <span className={`stat-chips stat-chips--${size} ${className}`}>
      {showPower && (
        <span className="stat-chip stat-chip--power" title={t('stat.power_hint', 'Power = Strength + Agility + Intellect')}>
          <span className="stat-chip__icon">⚡</span>
          {total}
        </span>
      )}
      {STATS.map((s) => (
        <span
          key={s.key}
          className={`stat-chip ${highlight && !highlight.has(s.key) ? 'stat-chip--dim' : ''}`}
          style={{ '--stat-color': s.color }}
          title={tr(t, s.name)}
        >
          <span className="stat-chip__icon">{s.icon}</span>
          {values[s.key] ?? 0}
        </span>
      ))}
    </span>
  );
}
